import { FC } from 'react';
import CommonHeader from '../CommonHeader';

interface ITicketConfirmationHeaderProps{}

const TicketConfirmationHeader: FC<ITicketConfirmationHeaderProps> = ()=>{
  return <CommonHeader/>;
}

export default TicketConfirmationHeader;